import { GET_PROFILES, GET_PROFILES_SUCCESS, API_ERROR } from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  profiles: [],
}

const ProfilesList = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROFILES:
      state = {
        ...state,
        loading: true,
      }
      break
    case GET_PROFILES_SUCCESS:
      state = {
        ...state,
        profiles: action.payload.profiles,
        loading: false,
        done: true,
      }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false, done: true }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default ProfilesList
